'use strict';

export default class OPLBackToTop {
    constructor() {
        this.backToTop = document.getElementById('back-to-top');
    }

    init() {
        const self = this;

        window.addEventListener('scroll', window.OPL.Utility.throttle(() => {
            const scrollHeight = document.documentElement.scrollHeight;
            const visibleHeight = window.innerHeight;
            const scrollPosition = window.scrollY || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

            if (scrollPosition > (scrollHeight - visibleHeight) / 2) {
                self.backToTop.style.display = 'block';
            } else {
                self.backToTop.style.display = 'none';
            }
        }, 20));

        self.backToTop.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
        });
    }
}
